export default "__VITE_ASSET__ZjWcAMcQ__"